module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<a\n    href="#fp_view_units"\n    aria-controls="units"\n    role="tab"\n    class="app-back-button"\n>\n    <span class="icon-font icon-arrow-left"></span>\n    Back\n</a>\n\n<div class="unit-header">\n    <div class="unit-overview lined-box">\n        ';
 if (unit && !hideUnitNumbers) { 
__p+='\n        <span>#'+
((__t=( unit.get("number") ))==null?'':__t)+
'</span>\n        ';
 } 
__p+='\n        <span>'+
((__t=( bedStr ))==null?'':__t)+
'</span>\n        <span>'+
((__t=( floorPlan.get("bath") ))==null?'':__t)+
' Bath</span>\n        <span>Sq. Ft. '+
((__t=( floorPlan.get("sq_ft") ))==null?'':__t)+
'</span>\n    </div>\n    ';
 if (visibleUnit) { 
__p+='\n    <div class="availability-overview lined-box">\n        '+
((__t=( apartmentType ))==null?'':__t)+
' is available for move-in starting on '+
((__t=( availableDate ))==null?'':__t)+
'\n    </div>\n    ';
 } 
__p+='\n</div>\n\n<ul id="fp_content_tab" class="fp-nav-tabs" role="tablist">\n    <li role="presentation" class="fp-tab-overview active">\n        <a\n            href="#fp_overview"\n            aria-controls="fp_overview"\n            role="tab"\n            data-toggle="tab"\n        >\n            Overview\n        </a>\n    </li>\n    ';
 if (photos.length) { 
__p+='\n    <li role="presentation" class="fp-tab-gallery">\n        <a\n            href="#fp_gallery"\n            aria-controls="fp_gallery"\n            role="tab"\n            data-toggle="tab"\n        >\n            Photos\n        </a>\n    </li>\n    ';
 } 
__p+='\n    ';
 if (description) { 
__p+='\n    <li role="presentation" class="fp-tab-desc">\n        <a\n            href="#fp_description"\n            aria-controls="fp_description"\n            role="tab"\n            data-toggle="tab"\n        >'+
((__t=( descriptionTitle ))==null?'':_.escape(__t))+
'</a>\n    </li>\n    ';
 } 
__p+='\n    ';
 if (amenities.length) { 
__p+='\n    <li role="presentation" class="fp-tab-amenities">\n        <a\n            href="#fp_amenities"\n            aria-controls="fp_amenities"\n            role="tab"\n            data-toggle="tab"\n        >\n            Amenities\n        </a>\n    </li>\n    ';
 } 
__p+='\n    ';
 if (has3D) { 
__p+='\n    <li role="presentation" class="fp-tab-3d">\n        ';
 if (panorama) { 
__p+='\n        <a\n            href="#fp_panorama"\n            aria-controls="fp_panorama"\n            class="panorama-tour-button"\n            fp-id="'+
((__t=( floorPlan.get('id') ))==null?'':__t)+
'"\n        >\n            Tour\n        </a>\n        ';
 } else if (tour) { 
__p+='\n        <tour-dialog-button fp-id="'+
((__t=( floorPlan.get('id') ))==null?'':__t)+
'" tour-id="'+
((__t=( tour ))==null?'':__t)+
'">\n        ';
 } 
__p+='\n        ';
 if (!panorama) { 
__p+='\n        <a\n            href="#fp_threed"\n            aria-controls="fp_threed"\n            ';
 if (!tour) { 
__p+='\n            role="tab"\n            data-toggle="tab"\n            ';
 } 
__p+='\n        >\n            3-D\n        </a>\n        ';
 } 
__p+='\n        ';
 if (tour) { 
__p+='\n        </tour-dialog-button>\n        ';
 } 
__p+='\n    </li>\n    ';
 } 
__p+='\n    ';
 if (hasGalleryTour) { 
__p+='\n    <li role="presentation" class="fp-tab-360">\n        ';
 if (galleryTour) { 
__p+='\n        <tour-dialog-button fp-id="'+
((__t=( floorPlan.get('id') ))==null?'':__t)+
'" tour-id="'+
((__t=( galleryTour ))==null?'':__t)+
'">\n        ';
 } 
__p+='\n        <a\n            href="#fp_threesixty"\n            aria-controls="fp_threesixty"\n            ';
 if (!galleryTour) { 
__p+='\n            role="tab"\n            data-toggle="tab"\n            ';
 } 
__p+='\n        >\n            360\n        </a>\n        ';
 if (galleryTour) { 
__p+='\n        </tour-dialog-button>\n        ';
 } 
__p+='\n    </li>\n    ';
 } 
__p+='\n    ';
 if (visibleUnit && unit.get("red_dot") && hasMap) { 
__p+='\n    <li role="presentation" class="fp-tab-location">\n        <a\n            href="#settings"\n            aria-controls="settings"\n            role="tab"\n        >\n            See Location\n        </a>\n    </li>\n    ';
 } 
__p+='\n    ';
 if (customLink && customLinkText) { 
__p+='\n    <li role="presentation" class="fp-tab-custom-link">\n        <a\n            href="'+
((__t=( customLink ))==null?'':__t)+
'"\n            target="_blank"\n            rel="noopener"\n            aria-label="(New Window)"\n            aria-controls="custom-link"\n        >\n            '+
((__t=( customLinkText ))==null?'':__t)+
'\n        </a>\n    </li>\n    ';
 } 
__p+='\n    ';
 if (customMobileLink && customMobileLinkText) { 
__p+='\n    <li role="presentation" class="fp-tab-custom-mobile-link">\n        <a\n            href="'+
((__t=( customMobileLink ))==null?'':__t)+
'"\n            target="_blank"\n            rel="noopener"\n            aria-label="(New Window)"\n            aria-controls="custom-mobile-link"\n        >\n            '+
((__t=( customMobileLinkText ))==null?'':__t)+
'\n        </a>\n    </li>\n    ';
 } 
__p+='\n\n</ul>\n\n<div class="floorplan-sub-tab tab-content">\n    <div id="fp_overview" class="tab-pane active" role="tabpanel">\n        <div class="fp-image-appicon-group">\n            <div class="fp-image lined-box">\n                <img src="'+
((__t=( floorPlan.get('image') ))==null?'':__t)+
'">\n            </div>\n            <div class="fp-custom-wrapper">\n                ';
 if (applicationLinkHTML || applicationUnitLinkHTML) { 
__p+='\n                <div class="app-icon-group">\n                    <div class="app-col">\n                        ';
 if (applicationUnitLinkHTML) { 
__p+='\n                            '+
((__t=( applicationUnitLinkHTML ))==null?'':__t)+
'\n                            ';
 if (useApplyUnitDescription) { 
__p+='\n                            <div class="application-link description-box">\n                                <p>'+
((__t=( applyUnitDescription ))==null?'':_.escape(__t))+
'\n                            </div>\n                            ';
 } 
__p+='\n                        ';
 } 
__p+='\n                        ';
 if (applicationLinkHTML) { 
__p+='\n                            '+
((__t=( applicationLinkHTML ))==null?'':__t)+
'\n                        ';
 } 
__p+='\n                    </div>\n                </div>\n                ';
 } 
__p+='\n                ';
 if (unitPromo) { 
__p+='\n                <div class="details-promotions" id="details_promotions">\n                    <div class="details-title-wrapper">\n                        <h3 id="details_promotions_heading">Promotions</h3>\n                        <img class="promo-tag details-promo-tag" src="/static/images/svg/promo-tag.svg" alt="promo tag icon" />\n                    </div>\n                    <p id="details_promotions_body">\n                        '+
((__t=( unitPromo ))==null?'':_.escape(__t))+
'\n                    </p>\n                </div>\n                ';
 } 
__p+='\n            </div>\n        </div>\n        <div class="fp-summary">\n            <div class="detailed-content ul-group">\n                <h3 class="lined-box">'+
((__t=( apartmentType ))==null?'':__t)+
' Summary</h3>\n                <ul class="list-unstyled">\n                    ';
 if (visibleUnit) { 
__p+='\n                    <li class="summary-detail-apartment">\n                        <span class="col-sm-2">'+
((__t=( apartmentType ))==null?'':__t)+
'</span>\n                        <span class="col-sm-10">'+
((__t=( unit.get("number") ))==null?'':__t)+
'</span>\n                    </li>\n                    ';
 } 
__p+='\n                    <li class="summary-detail-address">\n                        <span class="col-sm-2">Address</span>\n                        <span class="col-sm-10 address-info">\n                            <span>'+
((__t=( address ))==null?'':__t)+
'</span>\n                            <span>\n                                '+
((__t=( community.city ))==null?'':__t)+
',\n                                '+
((__t=( community.state ))==null?'':__t)+
'\n                                '+
((__t=( community.zip_code ))==null?'':__t)+
'\n                            </span>\n                        </span>\n                    </li>\n                    ';
 if (floor) { 
__p+='\n                    <li class="summary-detail-floor">\n                        <span class="col-sm-2">Floor</span>\n                        <span class="col-sm-10 address-info">\n                            <span>'+
((__t=( floor ))==null?'':_.escape(__t))+
'</span>\n                        </span>\n                    </li>\n                    ';
 } 
__p+='\n                    <li class="summary-detail-floorplan">\n                        <span class="col-sm-2">Floor Plan</span>\n                        <span class="col-sm-10">'+
((__t=( floorPlan.get("name") ))==null?'':__t)+
'</span>\n                    </li>\n                    <li class="summary-detail-bed-bath">\n                        <span class="col-sm-2">Beds/Baths</span>\n                        <span class="col-sm-10">\n                            '+
((__t=( bedStr ))==null?'':__t)+
' / '+
((__t=( floorPlan.get("bath") ))==null?'':__t)+
' Bath\n                        </span>\n                    </li>\n                    <li class="summary-detail-area">\n                        <span class="col-sm-2">Area</span>\n                        <span class="col-sm-10">'+
((__t=( area ))==null?'':__t)+
'</span>\n                    </li>\n                </ul>\n            </div>\n            <div class="lease-info ul-group">\n                <h3 class="lined-box" >Lease Info</h3>\n                <ul class="list-unstyled">\n                    ';
 if (unit) { 
__p+='\n                    <li class="summary-detail-move-in-date">\n                        <span class="col-sm-2">Move-In Date</span>\n                        <span class="col-sm-10">'+
((__t=( availableDate ))==null?'':__t)+
'</span>\n                    </li>\n                    ';
 } 
__p+='\n                    <li class="summary-detail-deposit">\n                        <span class="col-sm-2">Deposit</span>\n                        <span class="col-sm-10">'+
((__t=( deposit ))==null?'':__t)+
'</span>\n                    </li>\n                    <li class="summary-detail-rent">\n                        <span class="col-sm-2">Rent</span>\n                        <span class="col-sm-10">'+
((__t=( rent ))==null?'':__t)+
'</span>\n                    </li>\n                </ul>\n            </div>\n        </div>\n    </div>\n\n    ';
 if (photos.length) { 
__p+='\n    <div id="fp_gallery" class="fp-photo-gallery tab-pane" role="tabpanel">\n        <div id="fp_gallery_1" class="fp-gallery">\n            ';
 photos.forEach(function(img, idx) { 
__p+='\n            <a href="'+
((__t=( img.full ))==null?'':__t)+
'" data-gallery-index="'+
((__t=( idx ))==null?'':__t)+
'" class="gallery-img">\n                <img src="'+
((__t=( img.image ))==null?'':__t)+
'" alt=""/>\n            </a>\n            ';
 }) 
__p+='\n        </div>\n    </div>\n    ';
 } 
__p+='\n\n    ';
 if (description) { 
__p+='\n    <div id="fp_description" class="fp-description-container tab-pane" role="tabpanel">\n        <div class="fp-description-box">\n            <h3 class="lined-box">'+
((__t=( descriptionTitle ))==null?'':_.escape(__t))+
'</h3>\n            <p class="fp-description">'+
((__t=( description ))==null?'':_.escape(__t))+
'</p>\n        </div>\n    </div>\n    ';
 } 
__p+='\n\n    ';
 if (amenities.length) { 
__p+='\n    <div id="fp_amenities" class="fp-amenities-info tab-pane" role="tabpanel">\n        ';
 if (unitAmenities.length) { 
__p+='\n            <div class="fp-amenities-list">\n                <h3 class="lined-box">This '+
((__t=( apartmentType ))==null?'':__t)+
' Features</h3>\n                <ul class="fp-amenities-info-list bulletlist">\n                    ';
 unitAmenities.forEach(function(amenity) { 
__p+='\n                    <li>'+
((__t=( amenity ))==null?'':_.escape(__t))+
'</li>\n                    ';
 }) 
__p+='\n                </ul>\n            </div>\n        ';
 } 
__p+='\n        <div class="fp-amenities-list">\n            <h3 class="lined-box">Amenities</h3>\n            <ul class="fp-amenities-info-list bulletlist">\n                ';
 amenities.forEach(function(amenity) { 
__p+='\n                <li>'+
((__t=( amenity ))==null?'':_.escape(__t))+
'</li>\n                ';
 }) 
__p+='\n                ';
 if (selectUnits) { 
__p+='\n                <p class="select-units">* In Select '+
((__t=( apartmentTypeLong ))==null?'':__t)+
'</p>\n                ';
 } 
__p+='\n            </ul>\n        </div>\n    </div>\n    ';
 } 
__p+='\n\n    ';
 if (has3D) { 
__p+='\n    <div id="fp_threed"class="container-3d lined-box tab-pane" role="tabpanel">\n        ';
 if (tour) { 
__p+='\n        <tour-dialog-button fp-id="'+
((__t=( floorPlan.get('id') ))==null?'':__t)+
'" tour-id="'+
((__t=( tour ))==null?'':__t)+
'" class="btn btn-info fp-3d-button">Show 3D</tour-dialog-button>\n        ';
 } else { 
__p+='\n        <div class="canvas-container">\n        </div>\n        <div class="thumbs-3d">\n            <!-- <a class="thumb" data-frame="0" style="width: 120px; height: 68px; background-image: url(https://media.apts247.info/39/39b962927a7846a193773e9067541fb3/floorplans/flythrough_thumbnail/bernini.jpg); background-position: 0px 0px; background-repeat: no-repeat;"></a> -->\n        </div>\n        ';
 } 
__p+='\n    </div>\n    ';
 } 
__p+='\n</div>\n';
}
return __p;
};
